import styled, { DefaultTheme, css } from 'styled-components';
import Modal from 'styled-react-modal';
import { HeaderSecondary, TextBody } from '../typography/typography.styles';
import { CloseButtonContainer } from '../close-button/close-button.styles';

export const BASE_MODAL_Z_INDEX = 11000;

interface CustomModalProps {
  $widthModal: string;
  $heightModal?: string;
  $padding?: string;
  $paddingMobile?: string;
  $isMobileFullScreen?: boolean;
  $boxShadow?: string;
  theme: DefaultTheme;
}

export const ModalDialogContainer = Modal.styled`
  position: relative;
  padding: 3.2rem 4rem;
  padding: ${(props: CustomModalProps) => (props.$padding ? props.$padding : '3.2rem 4rem')};
  border-radius: 1.6rem;
  z-index: ${BASE_MODAL_Z_INDEX};
  font-family: ${({ theme }: { theme: DefaultTheme }) => theme.fonts.body.fontFamily};
  width: ${(props: CustomModalProps) => props.$widthModal};
  height: ${(props: CustomModalProps) => props.$heightModal ?? 'auto'};
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme.colors.namedColors.white};
  border: 1px solid  ${({ theme }: { theme: DefaultTheme }) => theme.colors.baseColors.grey50}; 
  margin-left: 16px;
  margin-right: 16px;
  overflow: hidden;
  box-shadow: ${({ $boxShadow }: CustomModalProps) => $boxShadow ?? 'none'};

  ${({ $heightModal }: CustomModalProps) =>
    $heightModal &&
    css`
      > div {
        height: 100%;
      }
    `}

  @media (max-width: 650px) {
    padding: ${(props: CustomModalProps) => (props.$paddingMobile ? props.$paddingMobile : '3.2rem 1.6rem')};

    ${HeaderSecondary} {
      text-align: center;
    }

    ${({ $isMobileFullScreen }: CustomModalProps) => {
      if (!$isMobileFullScreen) return;

      return css`
        width: 100%;
        height: 100%;
        margin: 0;
        border-radius: 0;
        border: 0;
      `;
    }}

  }

  ${CloseButtonContainer} {
    position: absolute;
    top: 1.6rem;
    right: 1.6rem;
    svg {
      padding: 4px;
    }
  }

  .mobile-qr-popup-link {
    font-weight: 500;
    line-height: 2.2rem;
  }

  .delete-dialog-title {
    display: flex;
    align-items: center;
    gap: 1.2rem;
  }
`;

interface ModalTextBodyProps {
  $textAlign?: string;
}

export const ModalTextBody = styled(TextBody)<ModalTextBodyProps>`
  margin: 1.6rem 0 2.4rem 0;
  color: ${({ theme }) => theme.colors.baseColors.grey100};
  letter-spacing: 0.5px;
  text-align: ${({ $textAlign = 'left' }) => $textAlign};
`;

export const ModalIconBody = styled(TextBody)`
  margin-top: 1.6rem;
  padding: 1.2rem;
  background-color: ${({ theme }) => theme.colors.baseColors.grey5};
  aspect-ratio: 1/1;
  border-radius: 1.2rem;
  img,
  svg {
    display: block;
    width: 100%;
    height: 100%;
    path {
      &:nth-child(2) {
        fill: #000000;
      }
    }
  }

  svg {
    cursor: pointer;
  }
`;
